import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core'
import { StorageService } from '../../../services'
import { OssConfig } from '../../../config'
import { StorageBucket } from '../../../models'

@Component({
  selector: 'app-single-image-upload-com',
  templateUrl: 'single-image-upload.com.html'
})

export class SingleImageUploadComponent implements OnInit, OnChanges {

  @Output() event = new EventEmitter<any>()
  @Input() original_key = null
  @Input() bucket: StorageBucket
  model = {
    config: OssConfig,
    source: null,
    allowed_extensions: ['jpg', 'png', 'bmp', 'jpeg', 'gif'],
    active: false,
    success: false,
    uploading: false
  }

  constructor(private storage: StorageService) {}

  ngOnInit() {
    this.model.source = this.bucket.get_url(this.original_key)
  }

  ngOnChanges() {
    this.model.source = this.bucket.get_url(this.original_key)
  }

  public onDragOver(e) {
    e.preventDefault()
    e.stopPropagation()
    this.model.active = true

  }

  public onDragLeave(e) {
    e.preventDefault()
    e.stopPropagation()
    this.model.active = false
  }

  public onDrop(e) {
    e.preventDefault()
    e.stopPropagation()
    const files = Array.from(e.dataTransfer.files)

    if (files.length > 0) {
      const valid_files: Array<File> = []
      files.forEach((f: File) => {
        if (this.fileExtensionGood(f)) { valid_files.push(f); }
      })
      if (valid_files.length > 0) { this.uploadOneFile(valid_files[0]); }
    }

  }

  public onFileInputChange(event) {
    const files = event.srcElement.files
    if (files.length && this.fileExtensionGood(files[0])) {
      this.uploadOneFile(files[0])
    }
  }

  private uploadOneFile(file) {
    if (file) {
      this.model.uploading = true
      const file_name = this.storage.timeStampedFileName(file.name)
      this.storage.uploadOneFile(this.bucket, file, file_name).then(result => {
        this.model.success = true
        this.model.uploading = false
        const url = this.bucket.get_url(file_name)
        this.model.source = url
        this.event.emit({
          source: 'single-image-upload',
          file_key: file_name
        })
      }).catch(error => {
        this.model.uploading = false
        this.event.emit({
          source: 'single-image-upload',
          url: null
        })
      })
    }
  }

  private fileExtensionGood(f: File): boolean {
    const ext = f.name.split('.')[f.name.split('.').length - 1].toLowerCase()
    return this.model.allowed_extensions.lastIndexOf(ext) !== -1
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/single-image-upload/single-image-upload.com.ts